import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";
import { CircularProgress, Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import { useAppSelector, useAppDispatch } from "../../hooks";
import { allFloorsType, doorType, GaragesData, GarageType } from './store/types'
import { ScenesItem, Icons, FloorItem, AvatarStyle } from './style'
import { selectGarageState, selectGaragesData, handleCloseOpenGaragesAsync, openCloseGarageAsync } from "./store/Garage/garageSlicer";
import './index.css'
const GarageDoors = () => {

  const dispatch = useAppDispatch();

  const Garages = useAppSelector(selectGaragesData)
  const garageState = useAppSelector(selectGarageState)


  const handleGarageDoor = (garage: GarageType) => {
    dispatch(openCloseGarageAsync(garage.id))
  }

  const handleOpenAll = () => {
    dispatch(handleCloseOpenGaragesAsync(true))
  }
  const handleCloseAll = () => {
    dispatch(handleCloseOpenGaragesAsync(false))
  }

  return (
    <Container maxWidth="lg">

      <Grid container spacing={4} sx={{ mt: 4 }} >
        <Grid sm={12} md={12}>
          <Typography
            variant="body1"
            sx={{ fontSize: 16, fontWeight: 400, color: "#909090" }}
          >
            SCENES
          </Typography>
        </Grid>

        <Grid container md={12} spacing={{ md: 2 }}>
          <Grid md={3}>
            <ScenesItem onClick={handleCloseAll}>
              <Avatar sx={AvatarStyle} src={Icons.GrageClosedYellow} />
              <Typography variant="body1" sx={{ fontSize: 18 }}>Close All</Typography>
            </ScenesItem>
          </Grid>
          <Grid md={3}>
            <ScenesItem onClick={handleOpenAll}>
              <Avatar sx={AvatarStyle} src={Icons.GrageOpenedYellow} />
              <Typography variant="body1" sx={{ fontSize: 18 }}>Open All</Typography>
            </ScenesItem>
          </Grid>
        </Grid>
      </Grid>

      <Grid container spacing={4} sx={{ mt: 4 }} >
        <Grid ip={12} md={12}>
          <Typography
            variant="body1"
            sx={{ fontSize: 16, fontWeight: 400, color: "#909090" }}
          >
            CONTROLS
          </Typography>
        </Grid>
        {!garageState.loading ?
          <Grid container md={12} spacing={{ md: 2 }}>
            {
              Garages.map((ele, i) => {
                return (
                  <Grid key={i} md={3} >
                    <FloorItem onClick={() => handleGarageDoor(ele)}>
                      {garageState.garageDoorLoading && garageState.selectedGarage === ele.id ? <CircularProgress size={20} color='inherit' sx={{ width: 31, height: 31, fontSize: 12, marginLeft: "15px" }} /> : <Avatar sx={{ width: 31, height: 31, marginLeft: "15px" }} src={ele.isOpened ? Icons.GrageClosedWhite : Icons.GrageClosedYellow} />}

                      <div className="floors-text">
                        <Typography variant="body1" sx={{ fontSize: 18, textTransform: "capitalize" }}>{ele.name} </Typography>
                        {garageState.garageDoorLoading && garageState.selectedGarage === ele.id ? <Typography variant="body1" sx={{ fontSize: 14, color: "#909090" }}> Loading... </Typography>
                          :
                          <Typography variant="body1" sx={{ fontSize: 14, color: "#909090" }}>{!ele.isOpened ? "CLOSED" : "OPENED"} </Typography>
                        }
                      </div>
                    </FloorItem>
                  </Grid>
                )
              })
            }

          </Grid>
          :
          <Grid container md={12} spacing={{ md: 2 }}>
            {
              Garages.map((ele, i) => {
                return (
                  <Grid key={i} md={3} >
                    <FloorItem onClick={() => handleGarageDoor(ele)}>
                      <div className="floors-text">
                        <CircularProgress size={20} color='inherit' sx={{ width: 31, height: 31, fontSize: 12, marginLeft: "15px" }} />
                        <Typography variant="body1" sx={{ fontSize: 18, textTransform: "capitalize" }}>{ele.name} </Typography>
                        <Typography variant="body1" sx={{ fontSize: 14, color: "#909090" }}> Loading... </Typography>
                      </div>
                    </FloorItem>
                  </Grid>
                )
              })
            }

          </Grid>
        }

      </Grid>

    </Container>
  );
};

export default GarageDoors;
